import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function SubtractThick({
  fillPrimary = colors.blue40,
  className,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 14 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[3px] w-[14px]', className)}
    >
      <path
        d="M0.984375 2.375C0.8125 2.375 0.651042 2.33073 0.5 2.24219C0.348958 2.14844 0.226562 2.02604 0.132812 1.875C0.0390625 1.71875 -0.0078125 1.54948 -0.0078125 1.36719C-0.0078125 1.1849 0.0390625 1.01823 0.132812 0.867188C0.226562 0.716146 0.348958 0.596354 0.5 0.507812C0.651042 0.414062 0.8125 0.367188 0.984375 0.367188H12.1953C12.3724 0.367188 12.5365 0.414062 12.6875 0.507812C12.8385 0.596354 12.9583 0.716146 13.0469 0.867188C13.1406 1.01823 13.1875 1.1849 13.1875 1.36719C13.1875 1.54948 13.1406 1.71875 13.0469 1.875C12.9583 2.02604 12.8385 2.14844 12.6875 2.24219C12.5365 2.33073 12.3724 2.375 12.1953 2.375H0.984375Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
